import { MetabaseCard } from '@shared/components/metabase';

export class SupplierReportModel extends MetabaseCard {}
